import React, { Fragment } from "react";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import MerchantProfile from "../components/MerchantProfile";
import EditMerchantProfile from "../components/EditMerchantProfile";
import { getMerchantProfile } from "../actions/merchantAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

class MerchantContainer extends React.Component {
  state = {
    activeKey: "show",
    display: "show",
  };

  componentDidMount() {
    this.props.getMerchantProfile(this.props.match.params.id);
  }

  show = () => {
    this.setState({ activeKey: "show" });
  };
  edit = () => {
    this.setState({ activeKey: "edit" });
  };

  render() {
    const { loading, merchant } = this.props.merchant;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            className="mt-2"
            id="left-tabs-example"
            activeKey={this.state.activeKey}
            mountOnEnter
            unmountOnExit
          >
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="show"
                      onSelect={() => this.setState({ activeKey: "show" })}
                    >
                      Merchant Profile
                    </Nav.Link>
                  </Nav.Item>
                  <LinkContainer exact to="/edit_profile/:id">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="edit"
                        onSelect={() => this.setState({ activeKey: "edit" })}
                      >
                        Edit Merchant Profile
                      </Nav.Link>
                    </Nav.Item>
                  </LinkContainer>
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="show">
                      <MerchantProfile merchant={merchant} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="edit">
                      <EditMerchantProfile
                        merchant={merchant}
                        show={this.show}
                        refresh={() =>
                          this.props.getMerchantProfile(
                            this.props.match.params.id
                          )
                        }
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ merchant }) => ({
  merchant: merchant,
});
const mapDispatchToProps = (dispatch) => ({
  getMerchantProfile: (merchant) => dispatch(getMerchantProfile(merchant)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MerchantContainer);
